import { render, staticRenderFns } from "./tv-choose.vue?vue&type=template&id=7fb52b2e&"
import script from "./tv-choose.vue?vue&type=script&lang=ts&"
export * from "./tv-choose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports